export const routePrefetchMap: Record<string, () => Promise<unknown>> = {};

const prefetched = new Set<string>();

export function prefetchRoute(path: string) {
  if (prefetched.has(path)) return;
  const loader = routePrefetchMap[path];
  if (loader) {
    prefetched.add(path);
    loader();
  }
}

export function prefetchIdleRoutes() {
  const priorities = Object.keys(routePrefetchMap);
  const run = () => priorities.forEach(prefetchRoute);
  if ('requestIdleCallback' in window) {
    requestIdleCallback(run, { timeout: 5000 });
  } else {
    setTimeout(run, 3000);
  }
}
